import React, { useEffect, useMemo, useState } from "react";
import { actions } from "@containers/SensorDataRestoringRequest/store";
import Progress from "rsuite/Progress";
import { useLoader } from "@shared/hooks";
import { Button } from "@shared/components";

import "./index.scss";

interface SensorDataRestoringRequestRestoreModalProps {
  onClose: () => void;
  onRestore: () => void;
}

const SensorDataRestoringRequestRestoreModal = (props: SensorDataRestoringRequestRestoreModalProps) => {
  const { onRestore, onClose } = props;

  const restoringLoading = useLoader({
    name: "SensorDataRestoringRequestRestoring",
    actionTypes: useMemo(() => [actions.restoreSensorDataRestoringRequest], []),
  });

  const [percent, setPercent] = useState(0);

  useEffect(() => {
    let interval: NodeJS.Timer | null = null;

    if (restoringLoading.isLoading) {
      interval = setInterval(() => {
        setPercent((prevPercent) => (prevPercent >= 100 ? 10 : prevPercent + 10));
      }, 500);
    }

    return () => {
      interval && clearInterval(interval);
    };
  }, [restoringLoading.isLoading]);

  return (
    <div className="modal-content-wrapper">
      <div className="modal-heading">Restore Data</div>
      <div className="modal-content">
        <div>{!restoringLoading.isLoading ? "Are you sure you want to restore data in Mongo DB?" : "Restoring..."}</div>
        {restoringLoading.isLoading ? (
          <div>
            <Progress.Line percent={percent} showInfo={false} />
          </div>
        ) : null}
      </div>
      <div className="modal-actions">
        <Button
          appearance="subtle"
          className="subtle auto-width"
          onClick={onClose}
          disabled={restoringLoading.isLoading}
        >
          Cancel
        </Button>
        <Button type="submit" className="blue auto-width" disabled={restoringLoading.isLoading} onClick={onRestore}>
          Restore
        </Button>
      </div>
    </div>
  );
};
export default SensorDataRestoringRequestRestoreModal;
